import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import DataProvider from '../firebase/DataProvider';
import { useFirebase } from '../firebase/FirebaseProvider';

function PrivateRoute({ component: Component, ...restProps }) {
    const { user } = useFirebase();
    return <Route
        {...restProps}

        render={props => {

            return user ?
                <DataProvider>
                    <Component  {...props} />
                </DataProvider>
                :
                <Redirect to={{
                    pathname: "/login",
                    state: {
                        from: props.location
                    }
                }} />
        }}
    />
}

export default PrivateRoute;
